import { render } from "./CameraScreen.vue?vue&type=template&id=8c6c5034&scoped=true"
import script from "./CameraScreen.vue?vue&type=script&lang=js"
export * from "./CameraScreen.vue?vue&type=script&lang=js"

import "./CameraScreen.vue?vue&type=style&index=0&id=8c6c5034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6c5034"]])

export default __exports__